import * as Yup from 'yup';

export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .required('Email is required')
    .email('Invalid email format'),
  password: Yup.string().required('Password is required'),
});

export const loginDefaultValues = {
  email: '',
  password: '',
};

export const signupSchema = Yup.object().shape({
  email: Yup.string()
    .required('Email is required')
    .email('Invalid email format'),
  password: Yup.string()
    .required('Password is required')
    .matches(
      /^(?=.*[A-Z])(?=.*\d).{8,}$/,
      'Password should be at least 8 characters and include at least one uppercase letter, one lowercase letter, one digit',
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm Password is required'),
});

export const signupDefaultValues = {
  email: '',
  password: '',
  referralCode: '',
  confirmPassword: '',
};

export const forgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .required('Email is required')
    .email('Invalid email format'),
});

export const forgotPasswordDefaultValues = {
  email: '',
};

export const resetPasswordSchema = Yup.object().shape({
  otp: Yup.string().required('otp is required'),
  password: Yup.string()
    .required('Password is required')
    .nullable()
    .matches(
      /^(?=.*[A-Z])(?=.*\d).{8,}$/,
      'Password should be at least 8 characters and include at least one uppercase letter, one lowercase letter, one digit',
    ),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref('password')],
    'Passwords must match',
  ),
});

export const resetPasswordDefaultValues = {
  otp: '',
  password: '',
};
